import { render, staticRenderFns } from "./WordleCorrectTilesInput.vue?vue&type=template&id=c27c68c4&scoped=true&"
import script from "./WordleCorrectTilesInput.vue?vue&type=script&lang=js&"
export * from "./WordleCorrectTilesInput.vue?vue&type=script&lang=js&"
import style0 from "./WordleCorrectTilesInput.vue?vue&type=style&index=0&id=c27c68c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c68c4",
  null
  
)

export default component.exports